import { fetchConToken } from '../helpers/fetch';

const TipoYSubtipoEfectoresService = {
  getTiposEfectores:()=>{
    return fetchConToken(`TipoEfector`)
  },
  getSubTiposEfectores:()=>{
    return fetchConToken(`SubTipoEfector`)
  },
  getSubtiposXTipoEfectores:(idTipoEfector)=>{
    return fetchConToken(`SubTipoEfector/traerPorTipoEfector/${idTipoEfector}`)
  }
}

export {TipoYSubtipoEfectoresService as default}